import { Vuex } from '../setup'

import state from './modules/state'
import user from './modules/user'
import match from './modules/match'
import league from './modules/league'
import order from './modules/order'
import adv from './modules/adv'
import route from './modules/route'
import question from './modules/question'
import search from './modules/search'
import raiders from './modules/raiders'
// TODO 添加custom state module
import custom from './modules/custom'
import attn from './modules/attn'
import ctcOrder from './modules/ctcOrder'
import wallet from './modules/wallet'
import sportsTour from './modules/sportsTour'
import travelOrder from './modules/travelOrder'

import plugins from './plugins'
import getters from './getters'
import actions from './actions'
import { DEBUG } from '../config'

const store = new Vuex.Store({
  strict: DEBUG,
  modules: {
    state,
    user,
    match,
    league,
    order,
    adv,
    /* route conflict with VueRouter */
    routes: route,
    question,
    search,
    raiders,
    custom,
    attn,
    ctcOrder,
    wallet,
    sportsTour,
    travelOrder,
  },
  getters,
  actions,
  plugins,
})

// See more: http://vuex.vuejs.org/en/hot-reload.html
if (module.hot) {
  module.hot.accept(['./modules/state'], () => {
    const newModuleState = require('./modules/state').default // eslint-disable-line global-require
    // swap in the new actions and mutations
    store.hotUpdate({
      modules: {
        state: newModuleState,
      },
    })
  })
}

export default store



// WEBPACK FOOTER //
// ./client/vuex/store.js